// extracted by mini-css-extract-plugin
export default {"cart":"Cart_cart__Miifg","btnCart":"Cart_btnCart__sOM4b"};